{
	"title": "Open-Source-Zuordnung",
	"backTitle": "Zurück"
}
